import React, { Component } from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core/styles";
import { style } from "../form/styles";
import Snackbar from "../../snackbar";
import { Divider } from "@material-ui/core";
import Header from "../../../partials/header";
import Loading from "../../loading";
import Form from "../form";

export class CreateProductMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      product: {
        date_created: null,
        date_updated: null,
        images: [],
        dimensions: {
          length: 0,
          width: 0,
          height: 0,
        },
        name: "",
        description: "",
        meta_description: "",
        meta_title: "",
        tags: [],
        attributes: [
          // {
          //     name : "Brand",
          //     value : "Brand A"
          // },
          // {
          //     name : "Size",
          //     value : "M"
          // }
        ],
        enabled: true,
        discontinued: false,
        slug: "",
        sku: "",
        code: "",
        tax_class: "",
        related_product_ids: [],
        prices: [],
        cost_price: 0,
        regular_price: 0,
        sale_price: 0,
        quantity_inc: 1,
        quantity_min: 1,
        weight: 0,
        stock_quantity: 1,
        position: null,
        date_stock_expected: null,
        date_sale_from: null,
        date_sale_to: null,
        stock_tracking: false,
        stock_preorder: false,
        stock_backorder: false,
        category_id: "",
        category_ids: [],
        variants: [],
      },
    };
  }
  insertProduct = async () => {
    let { t } = this.props;
    let product = this.form.getData();
    if (!product.name)
      this.mSnackbar.handleClick(
        t("product_please_fill_in_name_product"),
        "warning"
      );
    else {
      let imageGallery = this.form.getImageLibrary();
      let images = [];
      this.loading.startLoading();
      if (imageGallery.imageArr.length) {
        for (let i = 0; i < imageGallery.imageArr.length; i++) {
          let ele = imageGallery.imageArr[i];
          let checkUpload = await this.props.uploadDispatch.saveStorage({
            files: ele.file,
            code: this.props.serviceCode,
            type: "img-product",
          });
          if (checkUpload.code === 1) images.push(checkUpload.data.previewLink);
        }
      }
      product.images = images;
      product.date_created = new Date().getTime();
      await this.props.insertProduct(product);
      this.props.history.push("/productMenu/list");
      this.loading.stopLoading();
    }
  };
  render() {
    const { t, classes } = this.props;
    return (
      <>
        <Header
          session={t("sidebar_service_and_product")}
          title={t("sidebar_product")}
          button={t("product_create")}
          actionButton={this.insertProduct}
          backIcon={true}
          actionBack={() => this.props.history.push("/productMenu/list")}
        />
        <Snackbar
          color="white"
          onRef={(snackbar) => (this.mSnackbar = snackbar)}
        />
        <Divider className={classes.divider} />
        <Loading onRef={(id) => (this.loading = id)} />
        <Form
          data={this.state.product}
          onRef={(id) => (this.form = id)}
          type="create"
        />
      </>
    );
  }
}

const mapState = (state) => ({
  serviceCode: state.user.user.roleId.serviceCode,
});

const mapDispatch = (dispatch) => ({
  insertProduct: dispatch.product.insertProduct,
  uploadDispatch: dispatch.upload,
});

export default connect(
  mapState,
  mapDispatch
)(
  translate("translations")(
    withStyles(style, { withTheme: 0 })(CreateProductMenu)
  )
);
